export default __webpack_public_path__ + "static/media/reactfront.f9e764ed.svg";